/**
 * Validation rule `max_persons`
 * Checks if max number of people (children + kids) exceeds
 * a specified argument
 *
 * @example usage in field definition:
 * `max_persons:9`
 */
export default (kasko) => (context) => {
  const maxPersons = +context.args[0];
  if (!maxPersons) {
    throw new Error(
      '`max_persons` validator must have a valid specified argument. Please provide a max number of persons. Example: `max_persons:9`.',
    );
  }

  const formState = kasko.getFormState();

  const adults = +formState.adults;
  const kids = +formState.kids;

  if (Number.isNaN(adults) || Number.isNaN(kids)) {
    return null;
  }

  const totalPersons = adults + kids * 0.5;

  if (totalPersons <= maxPersons) {
    return null;
  }

  return { max_persons: true };
};
